import React from 'react';
import ReactECharts from 'echarts-for-react';
import LcNoData from '../../../../components/Generic/LcNoData';
import { ActivationChartModel } from '../../../../services/saas/SaasModel';

interface Props {
    data: ActivationChartModel[];
}

const ActiveChartPerSoftware: React.FC<Props> = (props) => {
    const filteredData = (data) => {
        return data.filter(obj => {
            for (const key in obj) {
                if (key !== 'productType' && obj[key] !== 0) {
                    return true;
                }
            }
            return false;
        });
    };

    const platformNames = ["Android", "iOS", "Mac", "Windows", "Windows 10 Mobile"];
    const platformNamestype =  ["android", "iOS", "mac", "windows", "windows10Mobile"];
    const colors = ["#a4ca39", "#777777", "#1d1d1f", "#0078d6", "#19588d"];

    const sortedData = filteredData(props.data).sort((a, b) => {
        const totalA = platformNamestype.reduce((acc, platform) => acc + a[platform], 0);
        const totalB = platformNamestype.reduce((acc, platform) => acc + b[platform], 0);
        return totalA - totalB; 
    });

    const productTotals = sortedData.map(item => {
        let productTotal = 0;
        platformNamestype.forEach(platform => {
            productTotal += item[platform];
        });
        return productTotal;
    });

    const series = platformNamestype.map((platform, index) => ({
        name: platformNames[index],
        type: 'bar',
        stack: 'devices',
        barWidth: 15,
        label: {
            show: true,
            position: 'right',
            formatter: function(params: any) {
                if (params.seriesIndex === series.length - 1) {
                    return productTotals[params.dataIndex];
                } else {
                    return params.value === 0 ? '' :'';
                }
            },
            textStyle: {
                color: '#8B90A39C'
            }
        },
        data: sortedData.map(item => item[platform]),
        itemStyle: {
            color: colors[index]
        }
    }));
    

    const option = {
        tooltip: {
            backgroundColor: '#f1f5fb',
            borderWidth: 0,
            textStyle: {
                fontSize: 10,
                fontFamily: 'Inter',
                color: '#2B304F',
            },
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        legend: {
            data: platformNames,
            bottom: 10,
            textStyle: {
                fontSize: 9 // Tamanho da fonte na legenda
            },
            icon: 'circle'
        },
        grid: {
            top: '5%',
            left: '0%',
            right: '5%',
            bottom: '15%',
            containLabel: true
        },
        yAxis: {
            type: 'category',
            data: sortedData.map(item => item.productType),
            axisLabel: {
                fontSize: 8 // Tamanho da fonte do eixo Y
            }
        },
        xAxis: [{
            show: false // Remover linhas verticais do grid
        }],
        series: series
    };

    return (
   <>
        {  
            props.data && props.data.length> 0 ?
            <ReactECharts
                opts={{ renderer: 'svg', locale: 'PT-br' }}
                style={{ height: '100%', width: '100%' }}
                option={option}
            />
            :
            <LcNoData/>
        }
   </> 
    );
};

export default ActiveChartPerSoftware;